import { render, staticRenderFns } from "./InterVideo.vue?vue&type=template&id=b032ebfc&"
import script from "./InterVideo.vue?vue&type=script&lang=js&"
export * from "./InterVideo.vue?vue&type=script&lang=js&"
import style0 from "./InterVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports